/**
 * Barra superior: dónde estoy y sobre qué datos.
 *
 * Ya no lleva la marca ni la cuenta —las dos viven en el menú lateral—, así que
 * mide 60 px en vez de 68 y no desperdicia el ancho. Lo que sí lleva es lo que
 * cambia al navegar: la ubicación, y el distintivo de ambiente.
 *
 * La ubicación es una MIGA, no el título de la página. El `<h1>` sigue en el
 * contenido, que es donde un documento pone su nombre; la miga responde a otra
 * pregunta —«¿en qué parte del sistema estoy?»— y por eso no es una repetición.
 *
 * El distintivo de ambiente es lo más importante que hay aquí. En un ambiente
 * que no es producción cambia de FORMA además de color: borde discontinuo y
 * ámbar, para que se note de reojo sin necesidad de leerlo.
 */

import type { Config } from "../api/types";

export interface Miga {
  /** Grupo del menú: «Contabilidad», «IVA y anexos»… */
  seccion?: string;
  /** Entrada del menú dentro del grupo. */
  pagina: string;
}

export function Topbar({ config, miga }: { config: Config; miga: Miga }) {
  const isProd = config.environment === "prod";

  return (
    <header className="topbar">
      <nav className="miga" aria-label="Ubicación">
        {miga.seccion && (
          <>
            <span className="miga-seccion">{miga.seccion}</span>
            <span className="miga-sep" aria-hidden="true">
              /
            </span>
          </>
        )}
        <span className="miga-pagina" aria-current="page">
          {miga.pagina}
        </span>
      </nav>

      <div className="topbar-spacer" />

      <span className={isProd ? "env-badge" : "env-badge nonprod"}>
        <span className="env-dot" aria-hidden="true" />
        {isProd ? "Producción" : config.environment} · Solo lectura
      </span>
    </header>
  );
}
